// Scroll reveal
document.addEventListener('DOMContentLoaded', function () {
  var revealEls = document.querySelectorAll('.reveal');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.15 });
  revealEls.forEach(function (el) { io.observe(el); });
});

// Product page: tabs
function setTab(el, id) {
  document.querySelectorAll('.tab').forEach(function (t) { t.classList.remove('active'); });
  document.querySelectorAll('.tab-panel').forEach(function (p) { p.classList.remove('active'); });
  el.classList.add('active');
  document.getElementById('panel-' + id).classList.add('active');
}

// Real Shopify AJAX add-to-cart
function daybaseAddToCart(form) {
  var formData = new FormData(form);
  fetch('/cart/add.js', { method: 'POST', body: formData })
    .then(function (res) { return res.json(); })
    .then(function () { window.location.href = '/cart'; })
    .catch(function (err) { console.error('Add to cart failed', err); alert('Could not add to bag — please try again.'); });
}
